import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Technical Screening Tool',
    title: 'Find top talent, fast',
    subtitle: 'AI-powered assessments built for the modern hiring world. Quickly identify the best candidates in your pipeline with skills-based screening.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #0076A3 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Screen for what matters',
      title: 'Build your hiring process around real skills',
      features: [
        { icon: '📝', title: 'AI-Generated Assessments', desc: 'Upload a JD and get a complete assessment in seconds — MCQ, coding, and short-answer questions tailored to your role.' },
        { icon: '🎯', title: 'Resume Parsing & Ranking', desc: 'Upload resumes in bulk. AI extracts skills, matches against your JD, and ranks candidates with a compatibility score.' },
        { icon: '⚡', title: 'Instant Scoring', desc: 'Multiple-choice scored instantly. Open-ended and coding answers evaluated by AI with rubric-based scoring and feedback.' },
      ],
      columns: 3,
    },
    {
      label: 'Technical Content',
      title: 'Quickly identify top candidates with high-quality questions',
      desc: 'Skip building tests from scratch. Upload a job description and have the system instantly create a unique assessment. Covering every major tech role and skill level.',
      bullets: ['50+ AI-generated question types', 'MCQ, short answer, and coding challenges', 'Difficulty levels: Easy, Medium, Hard', 'Per-skill scoring and breakdown', 'Export results as CSV'],
      visual: '📊',
      visualLabel: 'AI-Generated Assessment Dashboard',
    },
    {
      label: 'Integrity Built In',
      title: 'Advanced anti-cheating for every assessment',
      desc: 'Enforce your standards at scale with our comprehensive integrity stack — so you can trust every score.',
      bullets: ['Tab-switch and window-blur detection', 'Copy-paste and right-click monitoring', 'Per-question time tracking', 'AI-generated answer detection', 'Face presence verification'],
      visual: '🛡️',
      visualLabel: 'Anti-Cheating Integrity Stack',
    },
  ],
  testimonial: { quote: 'CHIRE cut our screening time by 80%. The AI scoring is remarkably accurate — we hired 3 senior engineers in 2 weeks.', name: 'Sarah K.', role: 'VP of Talent, TechCorp' },
  cta: { title: 'Start screening smarter today', desc: 'Create your first AI-powered assessment in minutes. Start with the Starter plan.' },
};

export default function AssessmentsPage() { return <ProductPageTemplate data={DATA} />; }
